import React, { useState, useEffect } from 'react';
import { OpDateTimepicker } from 'op2mise-react-widgets/OpDateTimepicker';
import { OpTextInput } from 'op2mise-react-widgets/OpTextInput';
import { Modal } from 'react-bootstrap';
import { dateUtils } from 'op2mise-react-widgets/OpSchedulerNext/utils';
import Button from 'shared/components/button/Button';
import './opEventDialog.css';

function OpEventDialog({
  eventData,
  mode,
  onCancel,
  onDelete,
  onSave,
  canDelete = true,
  canSave = true,
}) {
  const isCreateMode = mode === 'create';

  const [parameters, setParameters] = useState({
    start: new Date(),
    end: new Date(),
    title: '',
    description: '',
  });

  const changePeriod = (type, value) => {
    if (!value) return;

    setParameters((prev) => ({
      ...prev,
      [type === 'start' ? 'start' : 'end']: value,
    }));
  };

  const handleClose = () => {
    onCancel({
      eventData: null,
      mode: null,
      show: false,
    });
  };

  const handleSaveClick = () => {
    const start = dateUtils.parseToISOWithoutTimezone(parameters.start);
    const end = dateUtils.parseToISOWithoutTimezone(parameters.end);

    onSave(
      {
        ...parameters,
        end,
        start,
        startStr: start,
        description: parameters.description,
      },
      eventData,
      mode,
    );
  };

  const handleDelete = () => {
    onDelete(eventData);
  };

  useEffect(() => {
    if (!eventData) return;

    setParameters({
      start: new Date(eventData.start),
      end: new Date(eventData.end),
      title: eventData?.title ?? '',
      description: eventData?.description ?? '',
    });
  }, [eventData]);

  return (
    <Modal show centered size="md" className="op-event-dialog">
      <div className="op-event-dialog-wrapper">
        <div className="op-event-dialog-content">
          <div>
            <p id="op-event-dialog-label">
              {isCreateMode ? 'Create Event' : 'Edit Event'}
            </p>
            <OpTextInput
              value={parameters.title}
              onChange={(e) => setParameters((prev) => ({ ...prev, title: e.target.value }))}
              placeholder="Event Title"
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <p>Time Period</p>
            <OpDateTimepicker
              value={parameters.start}
              onChange={(e) => {
                changePeriod('start', e.value);
              }}
              cssClass="fullcalendar-date-time-picker-start"
              format="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showClearButton={false}
              allowEdit
            />
            <OpDateTimepicker
              value={parameters.end}
              onChange={(e) => {
                changePeriod('end', e.value);
              }}
              cssClass="fullcalendar-date-time-picker-end"
              format="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showClearButton={false}
              allowEdit
            />
          </div>

          <OpTextInput
            value={parameters.description}
            onChange={(e) => setParameters((prev) => ({ ...prev, description: e.target.value }))}
            placeholder="Event Description"
          />
        </div>

        <div className="op-event-dialog-actions">
          {!isCreateMode && canDelete && <Button text="Delete" onClick={handleDelete} />}
          {canSave && <Button text="Save" onClick={handleSaveClick} />}
          <Button text="Cancel" onClick={handleClose} />
        </div>
      </div>
    </Modal>
  );
}

export default OpEventDialog;
